<template>
  <div class="title-box">
    <b class="title">
      {{ stepList[index] }}
    </b>
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      stepList:[
        '一、主办单位证件核验',
        '二、主体负责人证件核验',
        '三、快应用负责人证件核验',
        '四、快应用负责人人脸识别',
        '核验结果如下',
      ],
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.title-box{
  display: flex;
  align-items: center;
  .title{
    font-size: 32px;
    font-weight: bold;
  }
}
</style>